var _g, _path, _path2, _path3, _circle, _circle2, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _circle3, _circle4, _path1, _path10, _path11, _circle5, _circle6, _path12, _circle7, _path13, _path14, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBat90(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 126,
    viewBox: "0 0 192 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_50240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.66 4.09931C48.619 1.47557 52.1599 0.599273 54.66 0.0993072C57.1602 -0.400659 64.1599 1.09925 66.16 2.09931C68.1602 3.09936 69.6592 10.0994 74.6592 11.5994C79.6592 13.0994 170.158 10.5994 173.159 10.5994C176.16 10.5994 180.659 14.7799 180.659 18.0994V28.5994C180.659 32.5994 180.659 35.5993 177.659 37.0994C173.159 39.3494 173.311 40.1721 171.659 42.0994C170.007 44.0267 170.057 44.6335 170.66 47.0993C171.56 50.7822 174.123 52.2816 176.659 55.0994C181.16 60.0994 182.325 61.1722 184.159 66.0994C186.424 72.1823 187.136 76.1086 187.159 82.5994C187.183 89.284 186.093 92.5923 183.16 98.5994C179.824 105.434 175.329 109.444 168.66 113.099C164.11 115.593 160.847 115.599 155.659 115.599C147.659 115.599 144.193 115.18 136.66 113.099C131.54 111.685 128.817 110.371 123.66 109.099C111.659 106.139 79.2945 107.493 72.6592 108.599C69.6592 109.099 61.6592 112.109 57.1592 114.099C51.802 116.469 46.6592 117.599 40.6592 117.599C34.7302 117.599 29.6592 116.099 27.1592 115.099C24.6592 114.099 18.1592 110.099 16.6592 108.599C15.1592 107.099 9.72751 100.63 7.66005 94.5993C5.47381 88.2221 4.24522 84.328 4.66005 77.5993C5.116 70.2037 6.3656 65.6376 10.66 59.5993C14.1094 54.7493 16.9843 52.5374 22.16 49.5993C29.1615 45.6249 38.1592 46.5994 42.16 44.5993C46.2523 42.5536 47.7018 39.7342 49.66 35.5993C51.9412 30.7826 53.4174 24.833 51.66 22.0993L47.16 15.0993C43.8861 10.7823 42.7011 6.72304 45.66 4.09931Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130.57 27.1144C130.166 29.537 125.298 30.9656 120.274 28.7295C111.047 27.008 104.123 24.8936 103.921 23.8842C103.719 22.8747 106.545 22.6729 106.545 22.6729H111.593L120.879 22.8747L126.734 22.6729C129.642 23.4717 130.974 24.6917 130.57 27.1144Z",
    fill: "black",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9427 82.8356L44.971 79.8073L53.4502 56.9941L48.6049 55.7828L50.0181 50.5337C50.0181 50.5337 51.2294 46.2943 50.8257 45.4866C50.4219 44.6789 46.8901 50.6849 44.971 58.0035L47.1917 59.6186L40.1257 81.2204L41.9427 82.8356Z",
    fill: "#ECEBEB",
    stroke: "black",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2857 43.0635L58.0107 40.6358L55.6706 39.9834L55.065 41.0446L52.8442 42.8616L50.2197 52.5521L52.2385 53.5616L54.2574 46.6974L55.6706 46.0918L57.2857 43.0635Z",
    fill: "#797979",
    stroke: "#797979"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.23019,
    cy: 3.23019,
    r: 4.23019,
    transform: "matrix(-1 0 0 1 45.1729 77.5864)",
    fill: "black",
    stroke: "black",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.283,
    cy: 30.283,
    r: 28.783,
    transform: "matrix(-1 0 0 1 72.2256 50.5337)",
    stroke: "black",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2202 57.1959L33.8674 105.043M68.7938 88.8921L15.4957 72.5393M26.1957 59.6185L59.507 103.832M65.9674 68.5015L17.1108 93.5355M37.0976 55.3789L47.3938 106.86M59.9108 60.0223L23.7731 102.015M15.092 83.2393L70.207 77.9902",
    stroke: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M113.006 53.5614L120.879 56.3878L121.889 52.552C122.247 51.6625 122.245 51.2105 121.687 50.5331L118.86 49.3218C116.9 49.0574 115.898 49.1813 114.217 49.7255L113.006 53.5614Z",
    fill: "black",
    stroke: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2941 25.3035L62.2513 25.9559C62.2513 25.9559 64.7068 22.4225 64.3516 19.8463C64.2288 18.9558 64.0581 18.4685 63.7459 17.6255C62.466 14.1687 54.5872 12.8348 57.4874 10.5595C57.8491 10.2757 58.2125 10.3151 58.4969 9.95384C59.2967 8.93782 57.2857 7.32942 56.4781 6.72376C55.6705 6.1181 53.6588 4.43606 53.2478 5.71422C52.9958 6.49783 54.1373 6.96044 53.8535 7.73309C53.7175 8.10312 53.4513 8.20301 53.2478 8.54064C52.5052 9.77287 51.9158 10.9327 52.6421 12.1746C53.1611 13.0619 54.0078 13.0172 54.8629 13.5878C56.319 14.5595 57.2471 14.9865 58.4969 16.2123C59.9495 17.6371 61.2019 18.4431 61.5252 20.452C61.8539 22.4952 60.2941 25.3035 60.2941 25.3035Z",
    fill: "#797979",
    stroke: "#797979"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M112.199 46.8995L114.419 47.5052L120.072 28.7297L117.65 28.3259L112.199 46.8995Z",
    fill: "#ECEBEB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M111.593 46.8995L114.823 47.707L112.602 53.7636L120.88 56.5901L120.476 58.2052L153.383 77.7882L155.402 80.8165L152.374 80.6146L119.668 60.8297L111.795 86.2674L114.419 86.8731L115.227 84.6523L150.961 81.2202V84.0466L118.457 87.4787L117.448 87.8825L116.842 95.3523L102.508 91.9202L101.499 88.8919L81.9156 71.5297L70.8118 55.3787L60.9194 38.2184L59.708 37.6127L58.6986 40.641L55.2665 39.2278L59.3043 25.4995L62.9382 26.7108V28.7297C72.3345 49.3692 77.4086 58.0072 85.9533 66.0787C93.1668 69.1193 97.3013 70.0375 104.931 69.5108L111.593 46.8995Z",
    fill: "#ECEBEB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M112.199 46.8995L114.419 47.5052L120.072 28.7297L117.65 28.3259L112.199 46.8995Z",
    stroke: "black"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M111.593 46.8995L114.823 47.707L112.602 53.7636L120.88 56.5901L120.476 58.2052L153.383 77.7882L155.402 80.8165L152.374 80.6146L119.668 60.8297L111.795 86.2674L114.419 86.8731L115.227 84.6523L150.961 81.2202V84.0466L118.457 87.4787L117.448 87.8825L116.842 95.3523L102.508 91.9202L101.499 88.8919L81.9156 71.5297L70.8118 55.3787L60.9194 38.2184L59.708 37.6127L58.6986 40.641L55.2665 39.2278L59.3043 25.4995L62.9382 26.7108V28.7297C72.3345 49.3692 77.4086 58.0072 85.9533 66.0787C93.1668 69.1193 97.3013 70.0375 104.931 69.5108L111.593 46.8995Z",
    stroke: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.283,
    cy: 30.283,
    r: 28.783,
    transform: "matrix(-1 0 0 1 181.647 50.5337)",
    stroke: "black",
    strokeWidth: 3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.23019,
    cy: 3.23019,
    r: 4.23019,
    transform: "matrix(-1 0 0 1 154.595 77.5864)",
    fill: "black",
    stroke: "black",
    strokeWidth: 2
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M159.642 57.1959L143.289 105.043M178.216 88.8921L124.918 72.5393M135.618 59.6185L168.929 103.832M175.389 68.5015L126.533 93.5355M146.519 55.3789L156.816 106.86M169.333 60.0223L133.195 102.015M124.514 83.2393L179.629 77.9902",
    stroke: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M101.297 79.2011L151.769 78.3936L151.971 83.2388L100.893 93.9388",
    stroke: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M105.536 81.2201L103.719 84.6522L104.527 86.0654L108.564 86.873L108.161 88.69L104.325 87.8824L103.315 89.2956L103.517 92.9296H101.7V89.6994L99.2777 88.8918L96.4513 90.305L95.8456 88.69L98.672 87.2767L98.8739 85.6617L96.2494 83.0371L97.2588 81.6239L100.287 84.2484L101.902 83.8447L103.719 80.4126L105.536 81.2201Z",
    fill: "black",
    stroke: "black"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.27736,
    cy: 8.27736,
    r: 6.77736,
    transform: "matrix(-1 0 0 1 110.18 78.3936)",
    stroke: "black",
    strokeWidth: 3
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.23019,
    cy: 3.23019,
    r: 3.23019,
    transform: "matrix(-1 0 0 1 104.931 83.6426)",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8458 101.61L101.902 89.0935L102.71 86.6708L100.893 85.8633L99.076 88.6897L93.2213 101.61H90.5968V103.629L91.6062 105.043H97.4609L98.6722 104.033V101.61H95.8458Z",
    fill: "black",
    stroke: "black"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.81698,
    cy: 1.81698,
    r: 1.81698,
    transform: "matrix(-1 0 0 1 56.0752 4.09961)",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M139.2 21H163.2V32H139.2V21Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M139.205 15.25C137.713 15.25 136.282 15.8426 135.228 16.8975C134.173 17.9524 133.58 19.3832 133.58 20.875V32.125C133.58 33.6168 134.173 35.0476 135.228 36.1025C136.282 37.1574 137.713 37.75 139.205 37.75H167.33C168.822 37.75 170.253 37.1574 171.308 36.1025C172.362 35.0476 172.955 33.6168 172.955 32.125V20.875C172.955 19.3832 172.362 17.9524 171.308 16.8975C170.253 15.8426 168.822 15.25 167.33 15.25H139.205ZM167.33 18.0625C168.076 18.0625 168.791 18.3588 169.319 18.8863C169.846 19.4137 170.143 20.1291 170.143 20.875V32.125C170.143 32.8709 169.846 33.5863 169.319 34.1137C168.791 34.6412 168.076 34.9375 167.33 34.9375H139.205C138.459 34.9375 137.744 34.6412 137.216 34.1137C136.689 33.5863 136.393 32.8709 136.393 32.125V20.875C136.393 20.1291 136.689 19.4137 137.216 18.8863C137.744 18.3588 138.459 18.0625 139.205 18.0625H167.33ZM178.58 26.5C178.58 27.6189 178.136 28.6919 177.344 29.4831C176.553 30.2743 175.48 30.7188 174.361 30.7188V22.2812C175.48 22.2812 176.553 22.7257 177.344 23.5169C178.136 24.3081 178.58 25.3811 178.58 26.5Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_50240",
    x: 0.580078,
    y: 0,
    width: 190.579,
    height: 125.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_50240"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_50240",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBat90);
export default __webpack_public_path__ + "static/media/bat_90.0c417d2d5ae8435c9925396f18a3a108.svg";
export { ForwardRef as ReactComponent };